module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-12.2daf93b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-12.jpg
// module id = FCW+
// module chunks = 0